import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../state/store";
import { DMGarrays, DMGnames } from "../images/DMG/index";
import { Platformer } from "../images/DMG/platformer/index";
import { stat } from "fs";

export interface GalleryState {
    generationNames: Array<string>;
    collectionArray: Array<Array<typeof module>>;
    currentName: string;
    currentCollection: Array<typeof module>;
    mainPicture: any;
}

export const gallerySlice = createSlice({
    name: "gallery",

    initialState: {
        generationArray: DMGnames,
        collectionArray: DMGarrays,
        currentName: "Platformer",
        currentCollection: Platformer,
        mainPicture: Platformer[0],
    },
    reducers: {
        changeGeneration: (state, action: PayloadAction<Array<string>>) => {
            state.generationArray = action.payload;
        },

        changeCollectionArray: (
            state,
            action: PayloadAction<Array<Array<typeof module>>>
        ) => {
            state.collectionArray = action.payload;
        },

        changeCurrentName: (state, action: PayloadAction<string>) => {
            state.currentName = action.payload;
        },

        changeCurrentCollection: (
            state,
            action: PayloadAction<Array<typeof module>>
        ) => {
            state.currentCollection = action.payload;
        },

        changeMainPicture: (state, action: PayloadAction<any>) => {
            state.mainPicture = action.payload;
        },
    },
});

export const {
    changeGeneration,
    changeCollectionArray,
    changeCurrentName,
    changeCurrentCollection,
    changeMainPicture,
} = gallerySlice.actions;

export const selectGenerationArray = (state: RootState) =>
    state.gallery.generationArray;
export const selectCollectionArray = (state: RootState) =>
    state.gallery.collectionArray;
export const selectCurrentName = (state: RootState) =>
    state.gallery.currentName;
export const selectCurrentCollection = (state: RootState) =>
    state.gallery.currentCollection;
export const selectMainPicture = (state: RootState) =>
    state.gallery.mainPicture;

export default gallerySlice.reducer;
